export const siteSettings = {
  name: "Alpha Edge",
  link: "https://alphaedgepro.live",
  email: "support@alphaedgepro.live",
  appLink: "https://app.alphaedgepro.live",
};
